module.exports = __webpack_public_path__ + "img/DefaultMapThumbnail.40666d99.png";